import React, { useEffect } from 'react';
import { Button, Separator, cn } from '@kiiwi/ui';
import { useTranslation } from '@/src/i18n';
import TLCSpecialityFilter from './TLCSpecialityFilter';
import TLCFeeFilter from './TLCFeeFilter';
import TLCPatientLimitationSwitch from './TLCPatientLimitationSwitch';

type Props = {
  filters: Record<string, any>;
  hasFiltersSelected: boolean;
  selectFilterValue: (filter: Record<string, any>) => void;
  resetAll: () => void;
};

const TLCDesktopFilterBar = ({
  filters,
  hasFiltersSelected,
  selectFilterValue,
  resetAll,
}: Props) => {
  const { t } = useTranslation();
  const [filterBarStyle, setFilterBarStyle] = React.useState<'lg' | 'sm'>('lg');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY <= 5) {
        setFilterBarStyle('lg');
      }
      if (window.scrollY >= 60) {
        setFilterBarStyle('sm');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div
        className={cn(
          'sticky top-14 z-40 flex w-full flex-col items-center justify-center bg-surface-white px-4',
          filterBarStyle === 'sm' && 'bg-surface-lighter px-0',
        )}
      >
        <div
          className={cn(
            'flex min-w-[756px] items-center justify-start space-x-3 py-8 transition-all duration-300 ease-linear',
            filterBarStyle === 'sm' && 'justify-center py-2',
          )}
          data-testid="filters"
        >
          <TLCSpecialityFilter
            filters={filters}
            selectValue={selectFilterValue}
          />

          <TLCFeeFilter filters={filters} selectValue={selectFilterValue} />

          <TLCPatientLimitationSwitch
            filters={filters}
            selectValue={selectFilterValue}
          />

          {hasFiltersSelected && (
            <Button variant="ghost" size="md" onClick={resetAll}>
              {t('reset-all')}
            </Button>
          )}
        </div>
        <Separator
          className={cn(
            filterBarStyle === 'sm' ? 'max-w-none' : 'max-w-[756px]',
          )}
        />
      </div>
    </>
  );
};

export default React.memo(TLCDesktopFilterBar);
